import React, { useState, useRef, useEffect } from "react";
import { endPoints, DefaultImageBaseurl, paymentEndpoints } from "../../../constant/Environment";
import {
  addData,
  deleteData,
  getAllPaymentFilterData,
  getAllData,
  fetchAllData,
} from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiOutlineEdit } from "react-icons/ai";
import { Delete } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import DeleteModel from "../../../components/DeleteModel";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const FreeSpins = (props) => {

  const {userId} = props;  
  const [editData, setEditData] = useState({});
  const [createData, setCreateData] = useState(false);
  const [gameId, setGameId] = useState("");
//   const [userId, setUserId] = useState("");
  const [freeSpinValue, setFreeSpinValue] = useState("");
  const [gameSearchTerm, setGameSearchTerm] = useState("");
  const [filteredGames, setFilteredGames] = useState([]);
  const [loadingGames, setLoadingGames] = useState(false);
  const [freeSpinGame, setFreeSpinGame] = useState(null);
  const [freeSpinGameName, setFreeSpinGameName] = useState("");
  const [spincount, setSpincount] = useState("");

  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);


  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchFreeSpins();
  }, []);


  const fetchFreeSpins = async () => {
    setIsLoading(true);
    let url = `${endPoints.apiBaseUrl}${endPoints.api.GET_FREE_SPINS}/${userId}`;
    try {
      const response = await getAllData(url);
      if (response?.status === "success") {
        setRows(response?.data || []);
        setIsLoading(false);
      } else {
        ErrorToast(response?.message || "Failed to fetch free spins");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching free spins:", error);
      // ErrorToast("Error fetching free spins");
      setIsLoading(false);
    } 
  };

  const searchGames = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
      setFilteredGames([]);
      return;
    }
    
    setLoadingGames(true);
    try {
      let url_gamesearch = `${endPoints.api.SEARCH_FREESPIN_GAMES}/${encodeURIComponent(searchTerm)}`;
      const response = await getAllData(url_gamesearch);
      
      if (response?.status === "success") {
        setFilteredGames(response?.data || []);
      } else {
        console.error("Failed to search games:", response);
        setFilteredGames([]);
      }
    } catch (error) {
      console.error("Error searching games:", error);
      setFilteredGames([]);
    } finally {
      setLoadingGames(false);
    }
  };

  // Debounced search for games
  useEffect(() => {
    const delayedGameSearch = setTimeout(() => {
      if (gameSearchTerm) {
        searchGames(gameSearchTerm);
      } else {
        setFilteredGames([]);
      }
    }, 500); // 500ms delay

    return () => clearTimeout(delayedGameSearch);
  }, [gameSearchTerm]);


  const handleOk = () => {
    if(gameId == ""){
      ErrorToast("Please select a game");
      return;
    }
    if(spincount == ""){
      ErrorToast("Please select number of spins");
      return;
    }
    if(freeSpinValue == ""){
      ErrorToast("Please enter free spin value");
      return;
    }
      let url = `${endPoints.api.ADD_FREE_SPINS}/${userId}`; // Replace with addspin endpoint

      let payload = {
        gameId: gameId,
        spinCount: Number(spincount),
        spinValue: Number(freeSpinValue * 100),
      };
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          // console.log("Response:", response);
          if (response?.data?.status === "success") {
            SuccesToast(response?.data?.message);
            fetchFreeSpins();
            handleClose();
          }
          else{
            ErrorToast(response?.data?.message);
            handleClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
  };

  useEffect(() => {
    if (editData) {
      setGameId(editData?.gameid || '');
    //   setUserId(editData?.userId || '');
      setFreeSpinValue(editData?.freespinvalue || '');
    }
  }, [editData]);

  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState('');


  useEffect(() => {
    setFilteredRows(rows);
  }, [rows]);

  const rowsToDisplay = filteredRows.length > 0 ? filteredRows : rows;


  return (
    <>
            {isLoading && <Loader spinner={true} visible={isLoading} />}
            <div className="inner-space12">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Free Spins
                  </Typography>
                  <Button
                    variant="primary"
                    className="mrglft10"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      setShow(true);
                      setEditData({});
                      setCreateData(true);
                      // Reset form fields
                      setGameId("");
                      setGameSearchTerm("");
                      setFilteredGames([]);
                    //   setUserId("");
                      setFreeSpinValue("");
                      setFreeSpinGame(null);
                      setFreeSpinGameName("");
                      setSpincount("");
                    }}
                  >
                    Add Free Spin
                  </Button>
                </div>
              </div>

              <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "0px 0px 12px 0px" }}>
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="Free spins table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Game Name</TableCell>
                            <TableCell align="center">No of spins</TableCell>
                            <TableCell align="center">Free Spin Value</TableCell>
                            <TableCell align="center">Created</TableCell>
                            <TableCell align="center">Expiry</TableCell>
                            {/* <TableCell align="center">Actions</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? rowsToDisplay.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                            : rowsToDisplay
                          ).map((row, index) => (
                            <TableRow
                              key={row.id || index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">
                                {row?.gameName}
                              </TableCell>
                              <TableCell align="center">{row?.spinCont || row?.spinCount}</TableCell>
                              <TableCell align="center">{Number(row?.spinValue)/100}</TableCell>
                              <TableCell align="center">{moment(row?.createdOn).format( "MM/DD/YYYY hh:mm")}</TableCell>
                              <TableCell align="center">{moment(row?.expiredOn).format( "MM/DD/YYYY hh:mm")}</TableCell>
                              {/* <TableCell align="center">
                                <div className="row">
                                  <div className="col-12">
                                    <AiOutlineEdit
                                      size={20}
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setEditData(row);
                                        setShow(true);
                                        setCreateData(false);
                                      }}
                                    />
                                  </div>
                                </div>
                              </TableCell> */}
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={6}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>

        <Modal
          className="modal-md modal-dialog-centered"
          show={show}
          onHide={handleClose}
          size="lg"
          centered
          dialogClassName="custom-modal-center"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {editData?.id ? 'Edit Free Spin' : 'Add Free Spin'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Game</Form.Label>
                  <Autocomplete
                    options={filteredGames}
                    getOptionLabel={(option) => option?.game_name || ""}
                    value={freeSpinGame || null}
                    onChange={(e, newValue) => {
                      setFreeSpinGame(newValue || null);
                      setGameId(newValue ? newValue?.game_id : "");
                      setFreeSpinGameName(newValue ? newValue?.game_name : "");
                      setGameSearchTerm(newValue ? newValue.game_name : "");
                      // Reset spin count and value when game changes
                      setSpincount("");
                      setFreeSpinValue("");
                    }}
                    onInputChange={(e, newInputValue, reason) => {
                      if (reason === "input") setGameSearchTerm(newInputValue);
                    }}
                    inputValue={gameSearchTerm}
                    loading={loadingGames}
                    loadingText="Searching games..."
                    noOptionsText={gameSearchTerm.length < 2 ? "Type at least 2 characters to search games" : "No games found"}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search and select game..."
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <>
                              {loadingGames ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    filterOptions={(x) => x} // Server-side filtering
                    isOptionEqualToValue={(o, v) => o?.game_id === v?.game_id}
                  />
                </Form.Group>
              </div>

              {freeSpinGame && (
                <>
                  <div className="col-md-6">
                    <Form.Group className="mb-3" controlId="spincount">
                      <Form.Label>Spin Count</Form.Label>
                      <Form.Select
                        value={spincount}
                        onChange={(event) => setSpincount(event.target.value)}
                      >
                        <option value="">Select Count</option>
                        {freeSpinGame?.freeCounts?.map((count) => (
                          <option key={count} value={count}>
                            {count}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="mb-3" controlId="freeSpinValue">
                      <Form.Label>Free Spin Value</Form.Label>
                      <Form.Select
                        value={freeSpinValue}
                        onChange={(event) => setFreeSpinValue(event.target.value)}
                      >
                        <option value="">Select Free Spin Value</option>
                        {freeSpinGame?.betSize?.map((betSize) => (
                          <option key={betSize} value={betSize}>
                            {betSize}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>
                </>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleOk}
              style={{
                background: "#04631e",
                borderColor: "#04631e",
              }}
            >
              {editData?.id ? 'Update Free Spin' : 'Add Free Spin'}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default FreeSpins;
